//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import DOMPurify from 'dompurify';
import constant from '~/const';

export default {
  props: {
    value: { type: Boolean, default: false },
  },

  computed: {
    ...mapState('templates', ['data']),
    ...mapState('tradersPaymentMethods', { paymentMethodsData: 'data' }),

    model: {
      get() {
        const { value } = this;
        return value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    hasDuplicateUniqueNames() {
      const uniqueNamesSet = new Set();
      return this.currentTemplate.fields.some((field) => {
        if (uniqueNamesSet.has(field.uniqueName)) {
          this.errorMessage.text = this.$t('Field name must be unique');
          this.errorMessage.show = true;
          return true;
        }
        uniqueNamesSet.add(field.uniqueName);
        this.errorMessage.text = '';
        this.errorMessage.show = false;
        return false;
      });
    },

    defaultTemplate() {
      return { name: '', fields: [{ ...this.defaultField }] };
    },

    getRelatedPaymentMethods() {
      return this.paymentMethodsData.filter((e) => e.template.name === this.currentTemplate.name);
    },

    getDeleteTemplatText() {
      switch (this.getRelatedPaymentMethods.length) {
        case 0:
          return this.$t('There is no payment methods with this template. You can safely delete this template');
        default:
          return this.$t('Unfortunately, there are payment methods linked with this template. You can not delete this template', { count: this.getRelatedPaymentMethods.length });
      }
    },

    getDeleteTemplateTitle() {
      switch (this.getRelatedPaymentMethods.length) {
        case 0:
          return this.$t('confirmAction.Are you sure you want to delete this template');
        default:
          return this.$t('confirmAction.You cant delete this template');
      }
    },
  },

  data() {
    return {
      constant,
      isEditing: false,
      errorMessage: {
        text: '',
        show: false,
      },
      defaultField: {
        uniqueName: '',
        type: constant.templates.TEMPLATE_TYPES.TEXT,
        IsRequired: true,
        isUniqueRequired: false,
        regex: '',
      },
      currentTemplate: {
        name: undefined,
        fields: [],
      },
      enumElements: [],
      modalManageFieldsTemplates: [
        {
          name: 'Credit card',
          fields: [
            {
              uniqueName: 'cardNumber',
              type: constant.p2p.PAYMENT_FIELD_TYPE.TEXT,
              IsRequired: true,
              // eslint-disable-next-line
              regex: '/^\d{16,18}/',
            },
            {
              uniqueName: 'cardOwner',
              type: constant.p2p.PAYMENT_FIELD_TYPE.TEXT,
              IsRequired: true,
              // eslint-disable-next-line
              regex: '/^[A-Za-z]* [A-Za-z]*/',
            },
            {
              uniqueName: 'validThru',
              type: constant.p2p.PAYMENT_FIELD_TYPE.TEXT,
              IsRequired: true,
              // eslint-disable-next-line
              regex: '/^\d{2}\/\d{2}/',
            },
            {
              uniqueName: 'CVV',
              type: constant.p2p.PAYMENT_FIELD_TYPE.INTEGER,
              IsRequired: true,
              // eslint-disable-next-line
              regex: '/^\d{3}/',
            },
          ],
        },
        {
          name: 'Internet wallets',
          fields: [
            {
              uniqueName: 'number',
              type: constant.p2p.PAYMENT_FIELD_TYPE.TEXT,
              IsRequired: true,
              regex: '',
            },
          ],
        },
        {
          name: 'SBPay',
          fields: [
            {
              uniqueName: 'phoneNumber',
              type: constant.p2p.PAYMENT_FIELD_TYPE.TEXT,
              IsRequired: true,
              regex: '',
            },
          ],
        },
        {
          name: 'Bank transfer',
          fields: [
            {
              uniqueName: 'nameOrOrganization',
              type: constant.p2p.PAYMENT_FIELD_TYPE.TEXT,
              IsRequired: true,
              regex: '',
            },
            {
              uniqueName: 'accountNumberOrIBAN',
              type: constant.p2p.PAYMENT_FIELD_TYPE.TEXT,
              IsRequired: true,
              regex: '',
            },
            {
              uniqueName: 'swiftCodeOrNameOrCorrespondentAccount',
              type: constant.p2p.PAYMENT_FIELD_TYPE.TEXT,
              IsRequired: true,
              regex: '',
            },
          ],
        },
      ],
    };
  },

  async mounted() {
    await this.loadData();
  },

  methods: {
    ...mapActions('common', [
      'confirmAction',
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('templates', {
      loadTemplates: 'loadData',
      editTemplateAction: 'editTemplate',
      addNewTemplateAction: 'addNewTemplate',
      deleteTemplateAction: 'deleteTemplate',
    }),

    addSelectorContent(fieldIndex) {
      const enums = this.currentTemplate.fields[fieldIndex].enumElements || [];
      enums.push({
        name: '',
        Value: enums.length + 1,
      });
      this.$set(this.currentTemplate.fields, fieldIndex, {
        ...this.currentTemplate.fields[fieldIndex],
        enumElements: enums,
      });
    },

    deleteSelectorContent(index, fieldIndex) {
      this.currentTemplate.fields[fieldIndex].enumElements.splice(index, 1);
    },

    deleteTemplate() {
      this.confirmAction({
        title: this.getDeleteTemplateTitle,
        text: this.getDeleteTemplatText,
        hasOkButton: this.getRelatedPaymentMethods.length === 0,
        callback: async () => {
          this.setGeneralLoader(true);
          try {
            await this.deleteTemplateAction(this.currentTemplate.id);
            await this.loadTemplates();
            this.setSuccessNotification('Template successfuly deleted');
          } catch (error) {
            this.setErrorNotification(error.message);
          }
          this.setGeneralLoader(false);
        },
      });
    },

    setCurrent(template, type) {
      this.isEditing = false;
      this.byDefault = false;

      switch (type) {
        case 'new':
          this.isEditing = false;
          this.currentTemplate.name = '';
          this.currentTemplate.fields = template.fields;
          break;
        case 'default':
          this.byDefault = true;
          this.currentTemplate.fields = template.fields;
          this.currentTemplate.name = template.name;
          this.currentTemplate.fields.enumElements = template.enumElements || [];
          break;
        default:
          this.isEditing = true;
          this.currentTemplate.name = template.name;
          this.currentTemplate.id = template?.id || undefined;
          this.currentTemplate.fields = template.fields;
          this.currentTemplate.fields.enumElements = template.enumElements || [];
          break;
      }
    },

    async loadData() {
      this.setGeneralLoader(true);
      await this.loadTemplates();
      this.setGeneralLoader(false);
    },

    async applyTemplate() {
      const template = { ...this.currentTemplate };
      template.fields = template.fields.map((field) => {
        const updatedField = { ...field };
        if (updatedField.type !== 3 && updatedField.enumElements) {
          delete updatedField.enumElements;
        }
        return updatedField;
      });
      this.setGeneralProgress(true);
      try {
        if (this.isEditing) {
          await this.editTemplateAction(template);
          this.setSuccessNotification('Template has been successfully edited');
        } else {
          await this.addNewTemplateAction(template);
          this.setSuccessNotification('Template has been successfully created');
        }
        await this.loadData();
        this.currentTemplate = {
          name: undefined,
          fields: [],
        };
        this.setGeneralProgress(false);
      } catch (error) {
        this.setErrorNotification(error);
      }
      this.setGeneralProgress(false);
    },

    sanitize(text) {
      return DOMPurify.sanitize(text, { USE_PROFILES: { html: true } });
    },

    addField() {
      this.currentTemplate.fields.push({
        uniqueName: '',
        type: constant.templates.TEMPLATE_TYPES.TEXT,
        IsRequired: true,
        regex: '',
      });
    },

    deleteField(id) {
      if (this.currentTemplate.fields.length > 1) {
        this.currentTemplate.fields.splice(id, 1);
      }
    },
  },
};
